export const isLastDayOfTheMonth = (date: Date): boolean => {
  return (
    date.getDate() ===
    new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
  );
};
